/**
 * System settings — LLM config. Operational, rarely touched.
 */
import { useEffect, useState } from 'react';
import * as api from '../../lib/api';
import { useToast } from '../../lib/toast';

export function SystemSettings() {
  const toast = useToast();
  const [llm, setLlm] = useState<api.LLMSettings | null>(null);
  const [busy, setBusy] = useState(false);
  const [model, setModel] = useState('claude-opus-4-7');
  const [key, setKey] = useState('');

  useEffect(() => {
    api.settings.getLLM().then((r) => {
      setLlm(r);
      setModel(r.model ?? 'claude-opus-4-7');
    }).catch((e) => toast.show(e.message, 'bad'));
  }, []);

  async function save() {
    setBusy(true);
    try {
      const r = await api.settings.setLLM({ provider: 'anthropic', model, api_key: key || undefined });
      setLlm(r);
      setKey('');
      toast.show('LLM settings saved', 'ok');
    } catch (e: unknown) {
      toast.show((e as Error).message, 'bad');
    } finally {
      setBusy(false);
    }
  }

  async function clearKey() {
    setBusy(true);
    try {
      const r = await api.settings.setLLM({ clear_api_key: true });
      setLlm(r);
      toast.show('API key cleared', 'info');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card p-4">
      <div className="text-sm font-semibold mb-1">LLM (Meeri's brain)</div>
      <div className="text-[11px] text-ink-mute mb-3">Anthropic Claude. Stored Fernet-encrypted.</div>
      <div className="space-y-2 text-xs">
        <div className="flex items-center gap-2">
          provider: <span className="pill">{llm?.provider ?? 'anthropic'}</span>
          <span className={llm?.api_key_set ? 'pill-sim' : 'pill text-ink-mute'}>{llm?.api_key_set ? 'key set' : 'no per-user key'}</span>
        </div>
        <label className="block">
          <span className="text-ink-mute">model</span>
          <input className="input w-full mt-1 num" value={model} onChange={(e) => setModel(e.target.value)} />
        </label>
        <label className="block">
          <span className="text-ink-mute">paste new API key</span>
          <input className="input w-full mt-1 font-mono" type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder="sk-ant-..." />
        </label>
        <div className="flex gap-2">
          <button className="btn" onClick={save} disabled={busy}>save</button>
          {llm?.api_key_set && <button className="btn" onClick={clearKey} disabled={busy}>clear</button>}
        </div>
      </div>
    </div>
  );
}
